export default class Phone {
  public id!: number
  public e164!: string
}
